import { Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { gql, useMutation, useQuery } from 'urql'
import FormDialog from '../dialogs/FormDialog'
import Spinner from '../loading/components/Spinner'
import { fieldErrors, nonFieldErrors } from '../util/errutil'
import ServiceSlackListForm, { Value } from './ServiceSlackListForm'

const mutation = gql`
  mutation UpdateSlackList($input: UpdateSlackListInput!) {
    updateSlackList(input: $input)
  }
`

const query = gql`
  query ($id: ID!) {
    slackList(id: $id) {
      id
      slackListID
      name
      ownerIDs
    }
    slackUsers {
      id
      name
      email
      teamID
    }
  }
`

export default function ServiceSlackListEditDialog(props: {
  listID: string
  onClose: () => void
}): JSX.Element {
  const [value, setValue] = useState<Value | null>(null)

  const [{ fetching: linking, error: linkError }, updateSlackList] =
    useMutation(mutation)
  const [{ data, fetching: dataFetching, error: dataError }] = useQuery({
    query,
    variables: { id: props.listID },
  })

  useEffect(() => {
    if (data && data.slackList && !value) {
      // Map ownerIDs (Slack IDs) to emails
      const ownerEmails = (data.slackList.ownerIDs || [])
        .map((id: string) => {
          const u = data.slackUsers.find((u: any) => u.id === id)
          return u ? u.email : null
        })
        .filter((e: string | null) => e !== null) as string[]

      setValue({
        name: data.slackList.name,
        owners: ownerEmails,
      })
    }
  }, [data])

  const loading = dataFetching || linking
  const error = linkError || dataError

  return (
    <FormDialog
      title='Edit Slack List'
      loading={loading}
      errors={nonFieldErrors(error)}
      onClose={props.onClose}
      onSubmit={() => {
        if (!value) return
        updateSlackList(
          {
            input: {
              id: props.listID,
              name: value.name,
              owners: value.owners,
            },
          },
          { additionalTypenames: ['SlackList'] },
        ).then((result) => {
          if (result.error) return
          props.onClose()
        })
      }}
      form={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {dataFetching && <Spinner />}
            {!dataFetching && value && (
              <ServiceSlackListForm
                errors={fieldErrors(error)}
                disabled={loading}
                value={value}
                users={data?.slackUsers || []}
                onChange={(newValue) => setValue(newValue)}
              />
            )}
          </Grid>
        </Grid>
      }
    />
  )
}
